import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#040914]">
      <Header />
      <main className="flex-1 pt-16 sm:pt-20">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
